import BaseModel from './BaseModel';
import * as AT from '../../components/container/attributes';
import {HitDateUtils} from '@hit/components/src/utils/date/HitDateUtils';
import ProjectPart from './ProjectPart';
import {HitOnlineEnums} from 'hit-online-web-ui/src/helpers/constants';
import {translate} from '../../plugins/i18n/i18n';

export default class PeriodicBill extends BaseModel {
  constructor({
    id,
    number,
    designation,
    beginDate,
    endDate,
    closed,
    salesAmount,
    projectPart,
    sortOrder,
    tags = [],
    status,
  }) {
    super(id, number, designation);
    this.beginDate = beginDate;
    this.endDate = endDate;
    this.closed = closed;
    this.salesAmount = salesAmount;
    this.projectPart = projectPart ? new ProjectPart(projectPart) : null;
    this.sortOrder = sortOrder;
    this.tags = tags;
    this.status = status
      ? HitOnlineEnums.getEnumValue(
          'PROJECT_PART_BILL_STATUS',
          status,
          translate,
        )
      : null;
  }

  get fastModeBrowserDesignation() {
    const begin = this.beginDate
      ? HitDateUtils.toShortDate(new Date(this.beginDate))
      : '';
    const end = this.endDate
      ? HitDateUtils.toShortDate(new Date(this.endDate))
      : '';
    const period = begin || end ? ` (${begin || '…'} - ${end || '…'})` : '';
    return `${this.fullDesignation}${period}`;
  }

  redirectToList(router) {
    router.push({
      name: 'projectPartDetail',
      params: {
        id: this.projectPart?.id ?? 0,
      },
    });
  }

  static get config() {
    const config = BaseModel.config;
    config['addable'] = false;
    config['importable'] = false;
    config['duplicatable'] = false;
    config['browsable'] = false;
    return config;
  }

  get config() {
    const config = BaseModel.config;
    config['addable'] = false;
    config['importable'] = false;
    config['duplicatable'] = false;
    config['browsable'] = false;
    return config;
  }

  static get fkName() {
    return 'bill_id';
  }
  static get apiRoute() {
    return 'project_part_bill';
  }
  static get detailPageRoute() {
    return 'periodicBilling';
  }
  static get listPageRoute() {
    return undefined;
  }
  get fkName() {
    return PeriodicBill.fkName;
  }
  get apiRoute() {
    return PeriodicBill.apiRoute;
  }
  get detailPageRoute() {
    return PeriodicBill.detailPageRoute;
  }
  get listPageRoute() {
    return PeriodicBill.listPageRoute;
  }

  static get joinAttrsKey() {
    return ['number', 'designation', 'beginDate', 'endDate', 'salesAmount'];
  }

  static get entityListDisplayAttrs() {
    return this.getAttributes(
      [
        'number',
        'designation',
        'beginDate',
        'endDate',
        'closed',
        'salesAmount',
        'tags',
        'status',
      ],
      ['sortOrder'],
    );
  }

  static get browserDisplayAttrs() {
    return this.getAttributes(
      ['number', 'designation', 'beginDate', 'endDate', 'salesAmount'],
      ['billDate', 'projectPart'],
    );
  }

  static get allAttributes() {
    return [
      this.NUMBER_ATTRIBUTE(),
      this.DESIGNATION_ATTRIBUTE({}, {maxWidth: '2fr'}),
      new AT.StringAttribute({
        name: 'memo',
        tableProperties: {
          header: 'hit-base.common.memo',
        },
      }),
      new AT.DateAttribute({
        name: 'beginDate',
        column: 'begin_date',
        tableProperties: {
          header: 'hit-app.common.begin-date',
          maxWidth: '1fr',
        },
      }),
      new AT.DateAttribute({
        name: 'endDate',
        column: 'end_date',
        tableProperties: {
          header: 'hit-app.common.end-date',
          maxWidth: '1fr',
        },
      }),
      new AT.DateAttribute({
        name: 'billDate',
        column: 'bill_date',
        tableProperties: {
          header: 'hit-app.common.bill-date',
          maxWidth: '1fr',
        },
      }),
      new AT.BooleanAttribute({
        name: 'closed',
        tableProperties: {
          header: 'hit-app.common.closed',
          maxWidth: '0.75fr',
        },
      }),
      new AT.DecimalAttribute({
        name: 'salesAmount',
        decimalPrecision: 2,
        column: 'sales_amount',
        tableProperties: {
          header: 'hit-app.common.amount',
          maxWidth: '1.5fr',
        },
      }),
      new AT.FkProjectPartAttribute({
        name: 'projectPart',
        joinPath: ['fk_project_part_bill_project_part_id_project_part'],
        column: 'project_part_id',
        tableProperties: {
          header: 'hit-base.common.project-part',
        },
      }),
      new AT.IntegerAttribute({
        name: 'sortOrder',
        column: 'sort_order',
        readOnly: true,
      }),
      this.TAGS_ATTRIBUTE({
        moduleUsage: 'project',
        tableOrigin: 'project_part_bill',
      }),
      new AT.EnumerationAttribute({
        name: 'status',
        enumType: 'PROJECT_PART_BILL_STATUS',
        enumClass: HitOnlineEnums,
        tableProperties: {
          propertyName: 'status',
          header: 'hit-app.common.status',
          maxWidth: '1.5fr',
        },
      }),
    ];
  }
}
